import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import { MenuLink, MenuSubtitle, MenuWrapper } from '../nav'

/**
 * A generic layout with a sidebar of links, and a right pane for routable sections
 */
export const RouteGroup = ({ routes }: { routes: IRoute[] }) => {
  return <Grid container spacing={1}>
    <Grid item xs={2}>
      <MenuWrapper>
        {
          routes.map((route, i) => route.details
            ? <MenuLink key={i} exact to={route.details.path}>{ route.label }</MenuLink>
            : <MenuSubtitle key={i}>{ route.label }</MenuSubtitle>
          )
        }
      </MenuWrapper>
    </Grid>
    <Grid item xs={10}>
      <Switch>
        {
          routes.map((route, i) => route.details
            ? <Route key={i} exact path={route.details.path} component={route.details.component} />
            : null
          )
        }
      </Switch>
    </Grid>
  </Grid>
}

export interface IRoute {
  label: string
  details?: {
    path: string
    component: () => JSX.Element
  }
}
